import { ActualWorkflowDataForTheDetailsPanelType } from "./ProcessTableDetailsPanel";
import { Button, Upload, UploadStatus, UploadSuccess } from "@avenueops/web-components";
import { PaperAirplaneIcon } from "@heroicons/react/20/solid";
import InputTextarea from "components/inputs/InputTextarea";
import Comment from "components/signals/processPage/Comment";
import { ProcessPageComments } from "components/signals/processPage/ProcessPageComments";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import Skeleton from "react-loading-skeleton";
import { toastError } from "utils/toast";
import { trpc } from "utils/trpc";
import { useFileUploadClient } from "utils/useFileUploadClient";

interface Props {
  processId: string;
}

export function CommentSection({ processId }: Props) {
  const { isLoading, data: process } = trpc.processes.get.useQuery({ processId: processId });

  return isLoading || process === undefined ? <Skeleton count={1} /> : <ProcessPageComments process={process} small />;
}
